import api from './api';
import { Gasto, PaginatedResponse } from '../types';

class GastosService {
  async getGastos(page = 1, limit = 10, search?: string, estado?: string): Promise<PaginatedResponse<Gasto>> {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (estado) params.append('estado', estado);

    const response = await api.get(`/gastos?${params.toString()}`);
    return response.data;
  }

  async getGastoById(id: number): Promise<Gasto> {
    const response = await api.get(`/gastos/${id}`);
    return response.data;
  }

  async createGasto(data: {
    numeroComprobante: string;
    fecha: string;
    beneficiario: string;
    concepto: string;
    valorTotal: number;
    observaciones?: string;
    estado?: 'pendiente' | 'pagado' | 'anulado';
    detalles: Array<{
      conceptoId: number;
      descripcion: string;
      cantidad: number;
      precioUnitario: number;
      descuentoPct?: number;
      subtotalBruto: number;
      montoDescuento: number;
      subtotalNeto: number;
    }>;
  }): Promise<Gasto> {
    const response = await api.post('/gastos', data);
    return response.data;
  }

  async updateGasto(id: number, data: Partial<{
    numeroComprobante: string;
    fecha: string;
    beneficiario: string;
    concepto: string;
    valorTotal: number;
    observaciones?: string;
    estado?: 'pendiente' | 'pagado' | 'anulado';
    detalles: Array<{
      conceptoId: number;
      descripcion: string;
      cantidad: number;
      precioUnitario: number;
      descuentoPct?: number;
      subtotalBruto: number;
      montoDescuento: number;
      subtotalNeto: number;
    }>;
  }>): Promise<Gasto> {
    const response = await api.patch(`/gastos/${id}`, data);
    return response.data;
  }

  async deleteGasto(id: number): Promise<void> {
    await api.delete(`/gastos/${id}`);
  }

  async getResumenMensual(year: number, month: number) {
    const response = await api.get(`/gastos/resumen-mensual/${year}/${month}`);
    return response.data;
  }

  async generateNumeroComprobante(year: number): Promise<string> {
    const response = await api.get(`/gastos/generar-numero/${year}`);
    return response.data;
  }
}

const gastosService = new GastosService();
export default gastosService;
